<template>
    <div class="home-container">
      <section class="d-flex flex-column-reverse flex-lg-row justify-content-end justify-content-lg-between align-items-start align-items-lg-center row-gap-2">
        <div class="d-flex gap-3" ref="getterButtonsWrappper">
          <p class="after-extra-large-text extra-black-color">ფლაერების ანალიტიკური ინფორმაცია</p>
        </div>
      </section>
      <section class="common-secondary-statistics">
        <div class="extra-black-color cursor-pointer" @click="activateModalMode('commonStatisticflyers', true), getCommonStatisticflyersdataForGraph(), getCommonStatisticflyerstableInfo()">
          <div class="d-flex align-items-center justify-content-between" style="border-bottom: 1px solid black; border-color: rgba(19, 21, 35, 0.25);">
            <p class="text-center after-extra-large-text" >დარიგებული ფლაერების რაოდენობა</p>
            <p class="text-center title-text">{{ commonStatisticsInfoObj?.flyer_count_sum }}</p>
          </div>
          <ul class="d-flex flex-column align-items-center justify-content-around">
            <li v-for="(flyerCountObj, i) of commonStatisticsInfoObj?.flyer_count" :class="['w-100', {'extra-blue-color': i % 2 == 0}, {'extra-green-color': i % 2 == 1}]" style="display: grid; grid-template-columns: 50% 50%; place-items: center;">
              <p class="after-extra-large-text text-center">{{ flyerCountObj.flyer_type }}</p>
              <p class="after-extra-large-text">{{ flyerCountObj.fl_count }} <span class="ms-3">{{ `${commonStatisticsInfoObj?.flyer_count_sum?(flyerCountObj.fl_count / commonStatisticsInfoObj?.flyer_count_sum * 100).toFixed():0}%`  }}</span></p>
            </li>
          </ul>
        </div>
        <commonStatisticsBlock visualWrapperHeight="65px" class="cursor-pointer" @click="activateModalMode('commonStatisticProblems', true), getCommonStatisticProblemstableInfo()">
          <template v-slot:title>
            <h6 class="light-text extra-gray-color">რა აწუხებს ხალხს</h6>
          </template>
          <template v-slot:correspondingInfo>
            <p v-if="true" class="after-extra-large-text extra-black-color">{{ commonStatisticsInfoObj?.problem_max_count?.length > 0?commonStatisticsInfoObj?.problem_max_count[0]?.door_problem_type:'' }}</p>
            <p v-else></p>
          </template>
          <template v-slot:chart>
            <commonStatisticsBarChart mode="red"/>
          </template>
        </commonStatisticsBlock>
        <commonStatisticsBlock visualWrapperHeight="65px" class="cursor-pointer" @click="activateModalMode('commonStatisticMood', true), getCommonStatisticMoodtableInfo()">
          <template v-slot:title>
            <h6 class="light-text extra-gray-color">პარტიის მიმართ დამოკიდებულება</h6>
          </template>
          <template v-slot:correspondingInfo>
            <ul class="w-100 pe-4">
              <li v-for="(moodCountObj, i) of commonStatisticsInfoObj?.mood_count" class="d-flex align-items-center justify-content-between w-100">
                <p :class="['light-text', {'extra-red-color': moodCountObj.moodID == 3}, {'extra-green-color': moodCountObj.moodID == 2}, 'font-weight-600']">{{ moodCountObj.mood }}</p>
                <p :class="['light-text', {'extra-red-color': moodCountObj.moodID == 3}, {'extra-green-color': moodCountObj.moodID == 2}, 'font-weight-600']">
                  <span class="large-text">{{ moodCountObj.mood_count }}</span>
                  <span class="large-text ms-4">{{ `${commonStatisticsInfoObj?.mood_count_sum? (moodCountObj.mood_count / commonStatisticsInfoObj?.mood_count_sum * 100).toFixed():0}%` }}</span>
                </p>
              </li>
            </ul>
          </template>
          <template v-slot:chart>
            <commonStatisticsBarChart mode="orange"/>
          </template>
        </commonStatisticsBlock>
        <commonStatisticsBlock visualWrapperHeight="65px" class="cursor-pointer" @click="activateModalMode('commonStatisticOppositionOrPosition', true), getCommonStatisticPartyTypetableInfo()">
            <template v-slot:title>
              <h6 class="light-text extra-gray-color">ოპოზიცია / პოზიცია</h6>
            </template>
            <template v-slot:correspondingInfo>
              <ul class="w-100 pe-4 d-flex flex-column">
                <li v-for="(party_typeCountObj, i) of commonStatisticsInfoObj?.party_type_count" class="d-flex align-items-center justify-content-between w-100">
                  <p :class="['light-text', {'extra-red-color': party_typeCountObj.party_typeID == 2}, {'extra-green-color': party_typeCountObj.party_typeID == 1}, 'font-weight-600']">{{ party_typeCountObj.party_type }}</p>
                  <p :class="['light-text', {'extra-red-color': party_typeCountObj.party_typeID == 2}, {'extra-green-color': party_typeCountObj.party_typeID == 1}, 'font-weight-600']">
                    <span class="large-text">{{ party_typeCountObj.pt_count }}</span>
                    <span class="large-text ms-4">{{ `${commonStatisticsInfoObj?.party_type_count_sum? (party_typeCountObj.pt_count / commonStatisticsInfoObj?.party_type_count_sum * 100).toFixed():0}%` }}</span>
                  </p>
                </li>
              </ul>
            </template>
            <template v-slot:chart>
              <commonStatisticsBarChart mode="green"/>
            </template>
        </commonStatisticsBlock>
        <commonStatisticsBlock visualWrapperHeight="80px" class="cursor-pointer" @click="activateModalMode('commonStatisticAttendance', true), getCommonStatisticGoingTypetableInfo()">
            <template v-slot:title>
              <h6 class="light-text extra-gray-color">არჩევნებზე სავარაუდო დასწრება</h6>
            </template>
            <template v-slot:correspondingInfo>
              <ul class="w-100 pe-4">
                <li v-for="(going_typeCountObj, i) of commonStatisticsInfoObj?.going_type_count" class="d-flex align-items-center justify-content-between w-100">
                  <p :class="['light-text', {'extra-red-color': going_typeCountObj.going_typeID == 2}, {'extra-green-color': going_typeCountObj.going_typeID == 1}, {'extra-orange-color': going_typeCountObj.going_typeID == 3}, 'font-weight-600']">{{ going_typeCountObj.going_type }}</p>
                  <p :class="['light-text', {'extra-red-color': going_typeCountObj.going_typeID == 2}, {'extra-green-color': going_typeCountObj.going_typeID == 1}, {'extra-orange-color': going_typeCountObj.going_typeID == 3}, 'font-weight-600']">
                    <span class="large-text">{{ going_typeCountObj.gt_count }}</span>
                    <span class="large-text ms-4">{{ `${commonStatisticsInfoObj?.going_type_count_sum? (going_typeCountObj.gt_count / commonStatisticsInfoObj?.going_type_count_sum * 100).toFixed():0}%` }}</span>
                  </p>
                </li>
              </ul>
            </template>
            <template v-slot:chart>
              <commonStatisticsBarChart mode="blue"/>
            </template>
        </commonStatisticsBlock>
      </section>
      <section class="d2d-map-section">
        <div class="d-flex justify-content-stretch w-100 gap-5" style="height: 100%;">
          <div class="d-flex flex-column gap-3 align-items-start">
            <Multiselect v-for="(data, i) of mapInfoTypesMultiselectArray" name="mapInfoType" id="mapInfoType" v-model="mapFiltersInfoObj.infoType" :options="data.options" :mode="data.mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
              :hideSelected="false" locale="ge" :canDeselect="false" :canClear="false" :required="false"
              @select="(value, option) => submitD2dMapFilters()" @deselect="() => submitD2dMapFilters()" @clear="() => submitD2dMapFilters()"
              class="extra-light-text light-blue-color custom-multiselect" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
            <commonStatisticsList listWidth="230px" :showOptionalHeader="false" :showTitle="false">
              <template v-slot:list>
                <template v-for="(cityObj, i) of mapListArray">
                  <li @click="getD2dDetailsForMap(cityObj)" :class="[{'active': cityObj.isChoosen}, {'ps-3': cityObj.cityID == 1}, 'map-list-element', 'common-transition', 'd-flex', 'align-items-center', 'justify-content-between', 'gap-3' ,'w-100', 'py-1', 'px-2', 'border-radius-10', 'cursor-pointer']">
                    <h5 class="extra-gray-color common-transition text-ellipsis text-start light-text">{{cityObj.city}}</h5>
                    <p class="before-extra-large-text">{{ cityObj.resp_count }}</p>
                  </li>
                </template>
              </template>
            </commonStatisticsList>
          </div>
          <div class="respodents-map-wrapper border-radius-10 w-100" style="height: 100%;">
            <markerMapComponent height="100%" :markersInfo="markerInfoArray" :zoomOn="zoomedMarkerIndex" :allowUnZoom="allowMapUnZoom" :zoomLevel="10"/>
          </div>
        </div>
      </section>
      <section class="d-flex flex-column gap-3 align-items-center">
      <h4 class="extra-large-text align-self-start">
        გამოკითხული პირები
      </h4>
      <div :class="['d-flex', 'flex-column', 'search-container', 'w-100', 'align-items-stretch']">
        <div class="d-flex justify-content-between align-items-center">
          <excelFileDownloadComponent @igniteDownload="igniteDownload" @abortDownload="abortD2DDataDownload" excelFileName="door2door" :namesArray="['door2door']" :jsonToExcelArray="jsonToExcelArray" :downloadInAction="downloadInAction" :canAbortDownload="true"/>
          <button @click="resetSupportersFilters()" type="button" class="extra-light-text extra-red-color ms-2" style="font-weight: 600; background-color: transparent;">გასუფთავება</button>
        </div>
        <hr style="margin: 0.5em 0 1em;">
        <form class="secondary-search-container-form w-100" @submit.prevent="submitD2DFilters">
          <fieldset class="filters-wrapper">
            <input v-model="d2dFiltersInfoObj.search" name="search-input" id="search-input" type="text" class="primary-input extra-light-text" placeholder="ძებნა"/>
            <Multiselect v-for="(data, i) of officeMultiselectArray" name="officeID" id="officeID" v-model="d2dFiltersInfoObj.officeID" :options="data.options" :mode="data.mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
              :hideSelected="false" locale="ge" :canDeselect="true" :canClear="true" :required="false"
              class="extra-light-text light-blue-color custom-multiselect" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
            <fieldset>
              <datePicker @update="handleDate" :rangeVmodelKeeper="d2dFiltersInfoObj.date" indicator="d2d-date-input"/>
            </fieldset>
            <Multiselect ref="cityID" v-model="d2dFiltersInfoObj.cityID" :options="this.d2dFiltersMultiselectsArray[1].options" :mode="this.d2dFiltersMultiselectsArray[1].mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1" id="cityID"
              :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 2, true, true, d2dFiltersMultiselectsArray, d2dFiltersInfoObj)" @deselect="() => blockNextMultiselects(2, d2dFiltersMultiselectsArray, d2dFiltersInfoObj)" @clear="() => blockNextMultiselects(2, d2dFiltersMultiselectsArray, d2dFiltersInfoObj)"
              class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.d2dFiltersMultiselectsArray[1].placeholder" :disabled="this.d2dFiltersMultiselectsArray[1].isDisabled" insert/>
            <Multiselect ref="regionID" v-model="d2dFiltersInfoObj.regionID" :options="this.d2dFiltersMultiselectsArray[2].options" :mode="this.d2dFiltersMultiselectsArray[2].mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
              :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 3, true, true, d2dFiltersMultiselectsArray, d2dFiltersInfoObj)" @deselect="() => blockNextMultiselects(3, d2dFiltersMultiselectsArray, d2dFiltersInfoObj)" @clear="() => blockNextMultiselects(3, d2dFiltersMultiselectsArray, d2dFiltersInfoObj)"
              class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.d2dFiltersMultiselectsArray[2].placeholder" :disabled="this.d2dFiltersMultiselectsArray[2].isDisabled" insert/>
            <Multiselect v-for="(data, i) of seenMultiselectArray" name="seen" id="seen" v-model="d2dFiltersInfoObj.seen" :options="data.options" :mode="data.mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
              :hideSelected="false" locale="ge" :canDeselect="true" :canClear="true" :required="false"
              class="extra-light-text light-blue-color custom-multiselect" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
            <Multiselect v-for="(data, i) of problemMultiselectArray" name="problemID" id="problemID" v-model="d2dFiltersInfoObj.problemID" :options="data.options" :mode="data.mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
              :hideSelected="false" locale="ge" :canDeselect="true" :canClear="true" :required="false"
              class="extra-light-text light-blue-color custom-multiselect" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
            <Multiselect v-for="(data, i) of moodMultiselectArray" name="moodID" id="moodID" v-model="d2dFiltersInfoObj.moodID" :options="data.options" :mode="data.mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
              :hideSelected="false" locale="ge" :canDeselect="true" :canClear="true" :required="false"
              class="extra-light-text light-blue-color custom-multiselect" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
            <Multiselect v-for="(data, i) of isGoingMultiselectArray" name="isGoing" id="isGoing" v-model="d2dFiltersInfoObj.isGoing" :options="data.options" :mode="data.mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
              :hideSelected="false" locale="ge" :canDeselect="true" :canClear="true" :required="false"
              class="extra-light-text light-blue-color custom-multiselect" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
            <Multiselect v-for="(data, i) of oppositionOrPositionMultiselectArray" name="oppositionOrposition" id="oppositionOrposition" v-model="d2dFiltersInfoObj.oppositionOrPosition" :options="data.options" :mode="data.mode"
              :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
              :hideSelected="false" locale="ge" :canDeselect="true" :canClear="true" :required="false"
              class="extra-light-text light-blue-color custom-multiselect" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
            <fieldset class="w-100 right-side">
                <div class="primary-helper-card d-flex align-items-center justify-content-center extra-black-color" style="border-radius: 5px;">
                  <p class="light-text font-weight-600">
                    რაოდენობა
                    <span class="extra-green-color">{{ d2dPagingInfo?.total > 0 ? d2dPagingInfo?.total : 0 }}</span>
                  </p>
                </div>
                <button type="submit" class="secondary-submit-btn d-flex align-items-center justify-content-center">
                  <p class="extra-light-text">
                    გაფილტვრა
                  </p>
                </button>
              </fieldset>
          </fieldset>
        </form>
      </div>
    </section>
      <section class="main-info-section d-flex flex-column gap-3 align-items-center" style="margin-top: -0.7em;">
        <div class="border-radius-20 w-100" style="background-color: var(--secondary-background-color); border-radius: 25px;">
          <div class="common-table-container common-scrollbar mt-2">
            <table class="common-tablee">
              <thead>
                <tr>
                  <th class="light-text light-blue-color">ქალაქი</th>
                  <th class="light-text light-blue-color">უბანი</th>
                  <th class="light-text light-blue-color">მისამართი</th>
                  <th class="light-text light-blue-color">დამ.თარიღ</th>
                  <th class="light-text light-blue-color">რა აწუხებს ხალხს</th>
                  <th class="light-text light-blue-color">დამოკიდებულება</th>
                  <th class="light-text light-blue-color">არჩვ.დასწრება</th>
                  <th class="light-text light-blue-color">პოზიცია</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d2dObj, i) of d2dDataArray" class="light-black-color light-text">
                  <td>{{ d2dObj.city??'უცნობია' }}</td>
                  <td>{{ d2dObj.region??'უცნობია' }}</td>
                  <td>{{ d2dObj.address??'უცნობია' }}</td>
                  <td>{{ this.$helper.get12HoursDate(`${d2dObj.input_date} ${d2dObj.input_time}`)??'უცნობია' }}</td>
  
                  <td>{{ d2dObj?.door_problem_type?.split(",")?.length > 0?d2dObj?.door_problem_type?.split(",")[0]:'უცნობია' }}</td>
                  <td :class="['light-text', 'font-weight-500', {'extra-green-color': d2dObj.moodID == 2}, {'extra-red-color': d2dObj.moodID == 3}]">{{ d2dObj.mood??'უცნობია' }}</td>
                  <td :class="['light-text', 'font-weight-500', {'extra-green-color': d2dObj.going_typeID == 1}, {'extra-red-color': d2dObj.going_typeID == 2}, {'extra-orange-color': d2dObj.going_typeID == 3}]">{{ d2dObj.going_type??'უცნობია' }}</td>
                  <td :class="['light-text', 'font-weight-500', {'extra-green-color': d2dObj.party_typeID == 1}, {'extra-red-color': d2dObj.party_typeID == 2}, {'extra-orange-color': d2dObj.party_typeID == 3}]">{{ d2dObj.party_type??'უცნობია' }}</td>
  
  
                  <td class="d-flex gap-4 align-items-center">
                    <img v-if="d2dObj.seen" src="@\assets\images\blue_Seen.svg" alt="seen">
                    <img v-else src="@\assets\images\disabled_seen.svg" alt="not seen">               
                    <primaryButtonComponent buttonWidth="max-content" class="extra-light-text" paddingY="8px" paddingX="10px" :mode="2" @click="activateModalMode('seeProblem'), seeProblem(d2dObj)">
                      <template v-slot:content>
                        დეტალურად
                      </template>
                    </primaryButtonComponent>             
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <vue-awesome-paginate
            :total-items="d2dPagingInfo.total"
            :items-per-page="d2dPagingInfo.limit"
            :max-pages-shown="4"
            v-model="d2dPagingInfo.offset"
            :hide-prev-next-when-ends="false"
            @click="paginationClickHandler"
            class="my-4"
          />
        </div>
      </section>
    </div>
    <primaryModalComponent :showModal="showModal" maxHeight="800px" :maxWidth="modalWidth" @closeModal="triggerModal">
          <template v-slot:modal-content>
            <div class="modal-content-wrapper d-flex flex-column align-items-center gap-4">
              <h5 class="before-extra-large-text">
                {{ modalTitle }}
              </h5>
              <div v-if="modalMode == 'seeProblem'" @submit.prevent="seeProblem" class="w-100 d-flex flex-column align-items-stretch gap-3">
                <ul class="w-100 modal-form-grid-wrapper">
                  <li v-for="(data, i) of Object.keys(seeProblemObj.props)" :class="['d-flex', 'flex-column', {'align-items-start': i % 2 == 0}, {'align-items-end': i % 2 == 1}, 'gap-1']">
                    <h6 class="light-gray-color light-text">{{ seeProblemObj.placeholders[data] }}</h6>
                    <div class="blue-part-input large-text text-start">
                      <p v-if="seeProblemObj.props[data]">{{seeProblemObj.props[data]}}</p>
                      <p v-else>-----------</p>
                    </div>
                  </li>
                </ul>
                <hr>
                <ul class="w-100 modal-form-grid-wrapper">
                  <li v-for="(data, i) of Object.keys(seeProblemObj.secondaryProps)" :class="['d-flex', 'flex-column', {'align-items-start': i % 2 == 0}, {'align-items-end': i % 2 == 1}, 'gap-1']">
                    <h6 class="light-gray-color light-text">{{ seeProblemObj.placeholders[data] }}</h6>
                    <div class="blue-part-input large-text text-start">
                      <p v-if="seeProblemObj.secondaryProps[data]">{{seeProblemObj.secondaryProps[data]}}</p>
                      <p v-else>-----------</p>
                    </div>
                  </li>
                </ul>
                <hr>
                <ul class="w-100 modal-form-grid-wrapper">
                  <li style="grid-column: 1 / 3;">
                    <article class="d-flex flex-column gap-2 align-items-start w-100">
                      <ul class="d-flex align-items-center flex-wrap gap-3">
                        <li v-for="(data, i) of seeProblemObj.additionalStatuses" class="blue-part-input green large-text text-start" style="width: fit-content; max-width: none; padding-inline: 25x;">
                          {{ data }}
                        </li>
                      </ul>
                    </article>
                  </li>
                </ul>
                <ul class="w-100 modal-form-grid-wrapper">
                  <li style="grid-column: 1 / 3;">
                    <article class="d-flex flex-column gap-2 align-items-start w-100">
                      <h4 class="light-text font-weight-600 light-black-color">პრობლემების სია</h4>
                      <ul class="d-flex align-items-center flex-wrap gap-3">
                        <li v-for="(data, i) of seeProblemObj.problems" class="blue-part-input large-text text-start border-radius-30" style="width: fit-content; max-width: none; padding-inline: 25x;">
                          {{ data }}
                        </li>
                      </ul>
                    </article>
                  </li>
                </ul>
                <ul class="w-100 modal-form-grid-wrapper">
                  <li style="grid-column: 1 / 3;">
                    <article class="d-flex flex-column gap-2 align-items-start w-100">
                      <h4 class="light-text font-weight-600 light-black-color">დამატებითი ტექსტი</h4>
                      <div class="blue-part-input large-text text-start" style="width: 100%; max-width: none; min-height: 100px;">
                        {{ seeProblemObj.additionalComment }}
                      </div>
                    </article>
                  </li>
                </ul>
                <hr>
                <ul class="w-100 modal-form-grid-wrapper">
                  <li v-for="(data, i) of Object.keys(seeProblemObj.footerProps)" :class="['d-flex', 'flex-column', {'align-items-start': i % 2 == 0}, {'align-items-end': i % 2 == 1}, 'gap-1']">
                    <h6 class="light-gray-color light-text">{{ seeProblemObj.placeholders[data] }}</h6>
                    <div class="blue-part-input large-text text-start">
                      <p v-if="seeProblemObj.footerProps[data]">{{seeProblemObj.footerProps[data]}}</p>
                      <p v-else>-----------</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div v-if="modalMode.startsWith('commonStatistic')" class="d-flex flex-column justify-content-between w-100 gap-3">
                <div v-if="modalMode == 'commonStatisticflyers'">
                  <div class="d-flex align-items-center justify-content-between">
                    <h6 class="before-extra-large-text font-family-400 text-start">Visitors Report</h6>
                    <Multiselect v-for="(data, i) of modalFlyerGraphDateMultiselectArray" name="modal-flyer-graph-date" id="modal-flyer-graph-date" v-model="d2dModalFiltersInfoObj.graphDate" :options="data.options" :mode="data.mode"
                      :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                      :hideSelected="false" locale="ge" :canDeselect="false" :canClear="false" :required="false"
                      @select="(value, option) => getCommonStatisticflyersdataForGraph()" @deselect="() => getCommonStatisticflyersdataForGraph()" @clear="() => getCommonStatisticflyersdataForGraph()"
                      class="extra-light-text light-blue-color custom-multiselect" style="width: min-content; max-width: min-content;" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
                  </div>

                  <div v-if="modalMode == 'commonStatisticflyers'" id="myPlot" style="width:100%;max-width:none;"></div>
                </div>

                <div class="d-flex flex-column justify-content-between w-100">
                  <form class="d2d-modal-form">
                    <autoSubmittedInput :Vmodel="d2dModalFiltersInfoObj.search" indicator="modal-flyer-search-input" @valueUpdated="updateModalFormSearch"/>
                    <fieldset>
                      <datePicker @update="handleModalFormDate" :rangeVmodelKeeper="d2dModalFiltersInfoObj.date" indicator="modal-flyer-date-input"/>
                    </fieldset>
                  </form>
                </div>
                <div :class="['d-flex', 'align-items-center', 'justify-content-between', 'gap-2']" style="overflow: hidden;">

                  <div v-if="modalMode == 'commonStatisticProblems'" class="d-flex flex-column gap-1" style="overflow: hidden;">
                    <h5 class="large-text extra-black-color font-weight-600 text-start">რა აწუხებს ხალხს</h5>
                    <div class="common-table-container common-scrollbar common-vertical-overflow common-horizontal-overflow">
                      <table class="common-tablee">
                          <thead>
                              <tr>
                                <th class="light-text light-blue-color text-start">
                                  <p>დასახელება</p>
                                </th>
                                <th class="light-text light-blue-color">
                                  <p>რაოდენობა</p>
                                </th>
                                <th v-for="(item, i) of problemsAscDescArray" @click="handleAscDescClick(problemsAscDescArray, i, d2dModalFiltersInfoObj), getCommonStatisticProblemstableInfo()" class="light-text light-blue-color">
                                  <ascDescBlock :isActive="item.isActive" :activeMode="item.activeMode" class="me-5">
                                    <template v-slot:text-content>
                                      {{ item.content }}
                                    </template>
                                  </ascDescBlock>
                                </th>
                              </tr>
                          </thead>
                          <tbody class="common-scrollbar common-vertical-overflow">
                              <tr v-for="(data, i) of modalLeftTableInfo"  class="light-black-color light-text"> 
                                <td class="text-start"><p>{{ data.name }}</p></td>
                                <td><p>{{ data.details.sum }}</p></td>
                                <td v-for="(item, i) of problemsAscDescArray">
                                  <span>{{ data.details[item.setValue]??0 }}</span>
                                  <span class="ms-3 extra-green-color">{{ `${(data.details.sum && data.details[item.setValue])?(data.details[item.setValue]/data.details.sum*100).toFixed() : 0}%` }}</span>
                                </td>
                              </tr>
                          </tbody>
                      </table>
                    </div>
                  </div>
                  <div v-if="modalMode != 'commonStatisticProblems'" class="d-flex flex-column gap-1 w-100" style="overflow: hidden;">
                    <div class="common-table-container common-scrollbar common-vertical-overflow common-horizontal-overflow">
                      <table style="table-layout: fixed;" v-if="modalMode == 'commonStatisticflyers'" class="common-tablee">
                        <thead>
                          <tr>
                            <th class="light-text light-blue-color text-start">
                              <p>დასახელება</p>
                            </th>
                            <th class="light-text light-blue-color text-center"><p>მონაცემების რაოდენობა</p></th>
                            <th v-for="(item, i) of flyersAscDescArray" @click="handleAscDescClick(flyersAscDescArray, i, d2dModalFiltersInfoObj), getCommonStatisticflyerstableInfo()" class="light-text light-blue-color">
                              <ascDescBlock :isActive="item.isActive" :activeMode="item.activeMode" :color="item.color">
                                <template v-slot:text-content>
                                    {{ item.content }}
                                </template>
                              </ascDescBlock>
                            </th>
                          </tr>
                        </thead>
                        <tbody class="common-scrollbar common-vertical-overflow">
                          <tr v-for="(data, i) of modalLeftTableInfo"  class="light-black-color light-text">
                            <td class="text-start"><p>{{data.name}}</p></td>
                            <td><p>{{ data.details.sum }}</p></td>
  
                            <td v-for="(item, i) of flyersAscDescArray">
                              <span>{{data.details[item.setValue]??0}}</span>
                              <span class="ms-3 extra-green-color">{{ `${(data.details.sum && data.details[item.setValue])?(data.details[item.setValue]/data.details.sum*100).toFixed() : 0}%` }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      
                      <table v-if="modalMode == 'commonStatisticMood'" class="common-tablee w-100">
                          <thead>
                              <tr>
                                <th class="light-text light-blue-color text-start">
                                  <p>დასახელება</p>
                                </th>
                                <th class="light-text light-blue-color text-center"><p>მონაცემების რაოდენობა</p></th>
                                <th v-for="(item, i) of moodsAscDescArray" @click="handleAscDescClick(moodsAscDescArray, i, d2dModalFiltersInfoObj), getCommonStatisticMoodtableInfo()" class="light-text light-blue-color">
                                  <ascDescBlock :isActive="item.isActive" :activeMode="item.activeMode" class="me-5" :color="item.color">
                                    <template v-slot:text-content>
                                      {{ item.content }}
                                    </template>
                                  </ascDescBlock>
                                </th>
                              </tr>
                          </thead>
                          <tbody class="common-scrollbar common-vertical-overflow">
                              <tr v-for="(data, i) of modalLeftTableInfo"  class="light-black-color light-text">
                                <td class="text-start"><p>{{ data.name }}</p></td>
                                <td><p>{{ data.details.sum }}</p></td>
                                <td v-for="(item, i) of moodsAscDescArray">
                                  <span>{{ data.details[item.setValue]??0 }}</span>
                                  <span :class="['ms-3', {'extra-green-color': item.moodID == 2},{'extra-red-color': item.moodID == 3}, {'extra-black-color': item.moodID == 1} ]">{{ `${(data.details.sum && data.details[item.setValue])?(data.details[item.setValue]/data.details.sum*100).toFixed() : 0}%` }}</span>
                                </td>
                              </tr>
                          </tbody>
                      </table>
                      <table v-if="modalMode == 'commonStatisticAttendance'" class="common-tablee">
                          <thead>
                              <tr>
                                <th class="light-text light-blue-color text-start">
                                  <p>დასახელება</p>
                                </th>
                                <th class="light-text light-blue-color text-center"><p>მონაცემების რაოდენობა</p></th>
                                <th v-for="(item, i) of attendanceAscDescArray" @click="handleAscDescClick(attendanceAscDescArray, i, d2dModalFiltersInfoObj), getCommonStatisticGoingTypetableInfo()" class="light-text light-blue-color">
                                  <ascDescBlock :isActive="item.isActive" :activeMode="item.activeMode" class="me-5" :color="item.color">
                                    <template v-slot:text-content>
                                      {{ item.content }}
                                    </template>
                                  </ascDescBlock>
                                </th>
                              </tr>
                          </thead>
                          <tbody class="common-scrollbar common-vertical-overflow">
                              <tr v-for="(data, i) of modalLeftTableInfo"  class="light-black-color light-text">
                                <td class="text-start"><p>{{ data.name }}</p></td>
                                <td><p>{{ data.details.sum }}</p></td>
                                <td v-for="(item, i) of attendanceAscDescArray">
                                  <span>{{ data.details[item.setValue]??0 }}</span>
                                  <span :class="['ms-3', {'extra-green-color': item.going_typeID == 1}, {'extra-red-color': item.going_typeID == 2}, {'extra-orange-color': item.going_typeID == 3}, {'extra-black-color': item.going_typeID == 4}]">{{ `${(data.details.sum && data.details[item.setValue])?(data.details[item.setValue]/data.details.sum*100).toFixed() : 0}%` }}</span>
                                </td>
                              </tr>
                          </tbody>
                      </table>
                       <table v-if="modalMode == 'commonStatisticOppositionOrPosition'" class="common-tablee">
                          <thead>
                              <tr>
                                <th class="light-text light-blue-color text-start">
                                  <p>დასახელება</p>
                                </th>
                                <th class="light-text light-blue-color">
                                  <p>მონაცემების რაოდენობა</p>
                                </th>
                                <th v-for="(item, i) of oppositionOrPositionAscDescArray" @click="handleAscDescClick(oppositionOrPositionAscDescArray, i, d2dModalFiltersInfoObj), getCommonStatisticPartyTypetableInfo()" class="light-text light-blue-color">
                                  <ascDescBlock :isActive="item.isActive" :activeMode="item.activeMode" class="me-5" :color="item.color">
                                    <template v-slot:text-content>
                                      {{ item.content }}
                                    </template>
                                  </ascDescBlock>
                                </th>
                              </tr>
                          </thead>
                          <tbody class="common-scrollbar common-vertical-overflow">
                              <tr v-for="(data, i) of modalLeftTableInfo"  class="light-black-color light-text">
                                <td class="text-start"><p>{{data.name}}</p></td>
                                <td><p>{{ data.details.sum }}</p></td>
                                <td>
                                  <span>{{ data.details.ოპოზიცია??0 }}</span>
                                  <span class="ms-3 extra-green-color">{{ `${(data.details.sum && data.details.ოპოზიცია)?(data.details.ოპოზიცია/data.details.sum*100).toFixed() : 0}%` }}</span>
                                </td>
                                <td>
                                  <span>{{ data.details.ნეიტრალური??0 }}</span>
                                  <span class="ms-3 extra-orange-color">{{ `${(data.details.sum && data.details.ნეიტრალური)?(data.details.ნეიტრალური/data.details.sum*100).toFixed() : 0}%` }}</span>
                                </td>
                                <td>
                                  <span>{{ data.details.პოზიცია??0 }}</span>
                                  <span class="ms-3 extra-red-color">{{ `${(data.details.sum && data.details.პოზიცია)?(data.details.პოზიცია/data.details.sum*100).toFixed() : 0}%` }}</span>
                                </td>
                              </tr>
                          </tbody>
                      </table>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </template>
      </primaryModalComponent>
  </template>
  
  <script>
/* <section>
        <QRCodeVue3
          value="https://www.youtube.com/@SosoAroundTheWorld"
          :downloadOptions="{ name: 'vqr', extension: 'png' }"
          fileExt="png"
          :download="true"
          :dotsOptions="{
            type: 'dots',
            color: '#000000',
            // gradient: {
            //   type: 'linear',
            //   rotation: 0,
            //   colorStops: [
            //     { offset: 0, color: '#000000' },
            //     { offset: 1, color: '#000000' },
            //   ],
            // },
          }"
          :cornersSquareOptions="{ type: 'square', color: '#000000' }"
          :cornersDotOptions="{ type: undefined, color: '#000000' }"
        />
      </section> */



  // @ is an alias to /src
  import primaryButtonComponent from "@/components/primaryButtonComponent.vue"
  import secondaryButton from "@/components/secondaryButton.vue"
  import commonStatisticsBlock from "@/components/commonStatisticsBlock.vue"
  import commonStatisticsList from "@/components/commonStatisticsList.vue"
  import searchFilterBarComponent from "@/components/search-filterBarComponent.vue"
  import primaryModalComponent from "@/components/primaryModalComponent.vue"
  import commonStatisticsBarChart from "@/components/commonStatisticsBarChart.vue"
  import datePicker from "@/components/datePicker.vue"
  import Multiselect from "@vueform/multiselect"
  import excelFileDownloadComponent from "@/components/excelFileDownloadComponent.vue";
  import markerMapComponent from "@/components/markerMapComponent.vue";
  import autoSubmittedInput from "@/components/autoSubmittedInput.vue"
  import ascDescBlock from "@/components/ascDescBlock.vue";
  import QRCodeVue3 from "qrcode-vue3";

  import { isProxy, toRaw } from 'vue';
  
  
  export default {
    name: "HomeView",
    data(){
      return {
        // for common statistics >>
        commonStatisticsInfoObj: {},
        // << for common statistics
        // for D2DData excel download >>
        jsonToExcelArray: [],
        downloadInAction: false,
        abortController: null,
        // << for D2DData excel download
        modalMode: null,
        showModal: false,
        // for common filter variables >>
        filteringPagingInfo: {
          d2dsearch: "",
          d2dcityID: null,
          d2dregionID: null,
          // d2ddistrictID: null,
          d2dOffset: null,
          d2dstartDateInputValue: null,
          d2dendDateInputValue: null,
          d2dseen: null,
          d2dofficeID: null,
          d2dproblemID: null,
          d2dmoodID: null,
          d2disGoing: null,
          d2doppositionOrPosition: null,
          d2dmapinfoType: null,
        },
        // << for common filter variables
        // for map filters >>
        mapFiltersInfoObj: {
          infoType: null,
        },
        mapInfoTypesMultiselectArray: [
          {
            placeholder: "გაფილტვრა",
            options: [
                {
                  value: 1,
                  label: {
                    ge: "ფლაერი",
                    en: "Flyre"
                  }
                },
                {
                  value: 2,
                  label: {
                    ge: "რა აწუხებს ხალხს",
                    en: "Problems"
                  }
                },
                {
                  value: 3,
                  label: {
                    ge: "დამოკიდებულება",
                    en: "Mood"
                  }
                },
                {
                  value: 4,
                  label: {
                    ge: "პოზიცია / ოპოზიცია",
                    en: "Position / Opposition",
                  }
                },
                {
                  value: 5,
                  label: {
                    ge: "არჩევნებზე დასწრება",
                    en: "Attendance",
                  }
                }
            ],
            mode: "single",
            isDisabled: false,
          }
        ],
        // << for map filters

        // for problem filters >>
        d2dDataArray: [],
        d2dFiltersInfoObj: {
          search: "",
          cityID: null,
          regionID: null,
          // districtID: null,
          date: [],
          startDateInputValue: null,
          endDateInputValue: null,
          seen: null,
          officeID: null,
          problemID: null,
          moodID: null,
          isGoing: null,
          oppositionOrPosition: null,
        },
        d2dPagingInfo: {
          limit: 10,
          offset: 1,
          total: 0,
        }, 
        activatedFilterMode: 0,
        d2dFiltersMultiselectsArray: [
          {},
          {
            placeholder: "ოლქი",
            options: [],
            mode: "single",
            isDisabled: false,
          },
          {
            placeholder: "უბანი",
            options: [],
            mode: "single",
            isDisabled: true,
          },
          {
            placeholder: "უბნის ნომერი",
            options: [],
            mode: "single",
            isDisabled: true,
          },
        ],
        seenMultiselectArray: [
          {
            placeholder: "ნანახი",
            options: [
                {
                  value: 1,
                  label: {
                    ge: "ნანახი(კი)",
                    en: "yes"
                  }
                },
                {
                  value: 0,
                  label: {
                    ge: "ნანახი(არა)",
                    en: "no"
                  }
                }
            ],
            mode: "single",
            isDisabled: false,
          }
        ],
        officeMultiselectArray: [
          {
            placeholder: "ოფისი",
            options: [],
            mode: "single",
            isDisabled: false,
          }
        ],
        problemMultiselectArray: [
          {
            placeholder: "რა აწუხებს ხალხს",
            options: [],
            mode: "single",
            isDisabled: false,
          }
        ],
        moodMultiselectArray: [
          {
            placeholder: "დამოკიდებულება",
            options: [],
            mode: "single",
            isDisabled: false,
          }
        ],
        isGoingMultiselectArray: [
          {
            placeholder: "არჩვ.დასწრება",
            options: [],
            mode: "single",
            isDisabled: false,
          }
        ],
        oppositionOrPositionMultiselectArray: [
          {
            placeholder: "ოპოზიცია/პოზიცია",
            options: [
                {
                  value: 1,
                  label: {
                    ge: "ოპოზიცია",
                    en: "opposition"
                  }
                },
                {
                  value: 2,
                  label: {
                    ge: "პოზიცია",
                    en: "position"
                  }
                },
                {
                  value: 3,
                  label: {
                    ge: "ნეიტრალური",
                    en: "neutral"
                  }
                }
            ],
            mode: "single",
            isDisabled: false,
          }
        ],
        // for marker map section >>
        isD2dDetailsForMapComing: false,
        mapListArray: [
          // {regionID: 2, resp_count: 4, city: 'დუბაი', isChoosen: false},
        ],
        markerInfoArray: null,
        allowMapUnZoom: null,
        zoomedMarkerIndex: null,
        choosenMapListElementObj: null,
        // for modal filters >>
        checkedElementInModalReport: null,
        d2dModalFiltersInfoObj: {
          search: null,
          date: null,
          sort: null,
          graphDate: 1,
        },
        modalFlyerGraphDateMultiselectArray: [
          {
            placeholder: "თარიღი",
            options: [
                {
                  value: 1,
                  label: {
                    ge: "კვირა",
                    en: "week"
                  }
                },
                {
                  value: 2,
                  label: {
                    ge: "დღე",
                    en: "day"
                  }
                }
            ],
            mode: "single",
            isDisabled: false,
          }
        ],
        flyersAscDescArray: [
          // {
          //   content: "ფლაერების რაოდენობა",
          //   setValue: "flyer_count",
          //   isActive: true,
          //   activeMode: false,
          // },
          // {
          //   content: "დასკანერებული",
          //   setValue: "ბეჭდური",
          //   isActive: true,
          //   activeMode: false,
          // },
          // {
          //   content: "დაგენერირებული",
          //   setValue: "ციფრული",
          //   isActive: false,
          //   activeMode: false,
          // },
        ],
        problemsAscDescArray: [
          // {
          //   content: "რაოდენობა",
          //   setValue: "problem_count",
          //   isActive: true,
          //   activeMode: false,
          // },
        ],
        moodsAscDescArray: [
          // {
          //   content: "დადებითი",
          //   setValue: "დადებითი",
          //   isActive: true,
          //   activeMode: false,
          //   color: '#1FD286',
          // },
          // {
          //   content: "უარყოფითი",
          //   setValue: "უარყოფითი",
          //   isActive: false,
          //   activeMode: false,
          //   color: '#F32E21',
          // },
          // {
          //   content: "უცნობია",
          //   setValue: "უცნობია",
          //   isActive: false,
          //   activeMode: false,
          //   color: '#131523',
          // },
        ],
        attendanceAscDescArray: [
          // {
          //   content: "მოვდივარ",
          //   setValue: "მოვდივარ",
          //   isActive: true,
          //   activeMode: false,
          //   color: '#1FD286',
          // },
          // {
          //   content: "თავს შევიკავებ",
          //   setValue: "თავს შევიკავებ",
          //   isActive: false,
          //   activeMode: false,
          //   color: '#FFCB10',
          // },
          // {
          //   content: "არ მოვდივარ",
          //   setValue: "არ მოვდივარ",
          //   isActive: false,
          //   activeMode: false,
          //   color: '#F32E21',
          // },
          // {
          //   content: "უცნობია",
          //   setValue: "უცნობია",
          //   isActive: false,
          //   activeMode: false,
          //   color: '#131523',
          // },
        ],
        oppositionOrPositionAscDescArray: [
          {
            content: "ოპოზიცია",
            setValue: "ოპოზიცია",
            isActive: true,
            activeMode: false,
            color: '#1FD286',
          },
          {
            content: "ნეიტრალური",
            setValue: "ნეიტრალური",
            isActive: false,
            activeMode: false,
            color: '#FFCB10',
          },
          {
            content: "პოზიცია",
            setValue: "პოზიცია",
            isActive: false,
            activeMode: false,
            color: '#F32E21',
          },
        ],
        // << for modal filters 
        // for modal >>
        modalWidth: '1240px',
        modalTitle: "",
        seeProblemObj: {
          props: {
            name: null,
            surname: null,
            age: null,
            gender: null,
            bornDate: null,
            telephone: null,
          },
          secondaryProps: {
            city: null,
            region: null,
            address: null,
            flatNumber: null,
          },
          footerProps: {
            responsiblePerson: null,
            office: null,
            personPhone: null,
          },
          placeholders: {
            name: 'სახელი',
            surname: 'გვარი',
            age: 'ასაკი',
            gender: 'სქესი',
            email: 'ელ-ფოსტა',
            telephone: 'ტელეფონის ნომერი',
            bornDate: 'დაბადების თარიღი',
            city: 'ქალაქი',
            region: 'უბანი',
            address: 'მისამართი',
            flatNumber: 'ბინის ნომერი',
            responsiblePerson: 'პასუხისმგებელი პირი',
            office: 'ოფისი',
            personPhone: 'ტელეფონის ნომერი',
          },
          problems: [],
          additionalStatuses: [],
          additionalComment: null,
        },
        // << for modal
        // for modal detailed tables >>
        modalLeftTableInfo: [],
        // << for modal detailed tables
      }
    },
    
    components: {
      primaryButtonComponent,
      secondaryButton,
      commonStatisticsBlock,
      commonStatisticsList,
      searchFilterBarComponent,
      primaryModalComponent,
      commonStatisticsBarChart,
      datePicker,
      Multiselect,
      excelFileDownloadComponent,
      markerMapComponent,
      autoSubmittedInput,
      ascDescBlock,
      QRCodeVue3,
    },
    beforeRouteUpdate(to, from, next){
      let isQueriesValid = this.getInfoFromRoute(to);
      if(isQueriesValid){
        if(this.activatedFilterMode == 0){
          this.manageD2DFilters();
          this.manageD2dMapFilters();
        }else if(this.activatedFilterMode == 1){
          this.manageD2DFilters();
        }else if(this.activatedFilterMode == 2){
          this.manageD2dMapFilters();
        }
        next(true);
      }else{
        next(false);
        this.$helper.showSwal("არასწორი მისამართი", "error", "");
      }
      this.activatedFilterMode = 0;
    },
    mounted(){
      this.routerMountMovement(this.$route);
      this.$watch(() => this.d2dFiltersMultiselectsArray[1].options, (newOptions, oldOptions) => {
        this.d2dFiltersInfoObj.cityID = this.d2dFiltersInfoObj.cityID;
        
          if(this.d2dFiltersInfoObj.cityID){
            this.allowNextMultiselect(this.d2dFiltersInfoObj.cityID, 2, false, false, this.d2dFiltersMultiselectsArray, this.d2dFiltersInfoObj);
              
          }
        },
        { deep: true }
      );
      this.$watch(() => this.d2dFiltersMultiselectsArray[2].options, (newOptions, oldOptions) => {
          this.d2dFiltersInfoObj.regionID = this.d2dFiltersInfoObj.regionID;
          if(this.d2dFiltersInfoObj.regionID){
              this.allowNextMultiselect(this.d2dFiltersInfoObj.regionID, 3, false, false, this.d2dFiltersMultiselectsArray, this.d2dFiltersInfoObj);
          }
        },
        { deep: true }
      );
      this.$watch(() => this.d2dFiltersMultiselectsArray[3].options, (newOptions, oldOptions) => {
          this.d2dFiltersInfoObj.regionID = this.d2dFiltersInfoObj.regionID;
        },
        { deep: true }
      );
    },
    methods: {
      routerMountMovement(to){
        let isQueriesValid = this.getInfoFromRoute(to);
        
        if(isQueriesValid){
          this.removeAriaHidden();
          this.getOffices();
          this.getMoods();
          this.getFlyerTypes();
          this.getGoingTypes();
          this.getCitiesAll([this.d2dFiltersMultiselectsArray]);
          this.manageD2DFilters();
          this.manageD2dMapFilters();
        }else{
          this.$router.replace(this.$route.path);
          this.$helper.showSwal("არასწორი მისამართი", "error", "");
        }
        this.activatedFilterMode = 0;
      },
      getInfoFromRoute(to){
        Object.keys(this.filteringPagingInfo).forEach((key) => {
          this.filteringPagingInfo[key] = to.query[key]?decodeURIComponent(to.query[key].replace(/%/g, '%25')):null;
        })
        
        let isQueriesValid = Object.keys(this.filteringPagingInfo).every((key) => {
          if(key == "d2dsearch"){
            return this.$helper.checkJustOptionalString(this.filteringPagingInfo[key]??"");
          }else if(key == "d2dstartDateInputValue" || key == "d2dendDateInputValue"){
            return this.$helper.checkDateWithRegex(this.filteringPagingInfo[key]??"");
          }else if(this.filteringPagingInfo[key] == null){
            return true;
          }else{
            return this.$helper.checkOptionalNumber(this.filteringPagingInfo[key]);
          }
        });
        
        return isQueriesValid;
      },
      getD2dMapListInfo(){
        this.markerInfoArray = [];
        this.allowMapUnZoom = true;
        this.zoomedMarkerIndex = null;
        if(this.choosenMapListElementObj?.isChoosen == true){
          this.choosenMapListElementObj.isChoosen = false;
        }
        this.choosenMapListElementObj = null;

        this.mapListArray = [];


        let localEndpointName = "";
        switch (this.mapFiltersInfoObj.infoType) {
          case 1:
            localEndpointName = "countsByCityAndFlyerTypes";
            break;
          case 2:
            localEndpointName = "user_door_problem_type_detail_counts";
            break;
          case 3:
            localEndpointName = "user_doors_mood_detail_counts";
            break;
          case 4:
            localEndpointName = "user_door_party_type_detail_counts";
            break;
          case 5:
            localEndpointName = "user_door_going_type_detail_counts";
            break;
          default:
            this.mapFiltersInfoObj.infoType = 1;
            localEndpointName = "countsByCityAndFlyerTypes";
            break;
        }

        
        this.$store.dispatch(`${localEndpointName}`, {}).then((response) => {
          Object.keys(response.data).forEach((key) => {

            let sum = Object.values(response.data[key]).reduce((accumulator, num) => {
              return accumulator + num;
            }, 0);
            this.mapListArray.push({
              city: key,
              resp_count: sum,
              isChoosen: false,
            });
            this.mapListArray.sort((a, b) => {
              return b.resp_count - a.resp_count;
            });
          });
        });


      },
      manageD2dMapFilters(){
        Object.keys(this.mapFiltersInfoObj).forEach((key) => {
          if(this.filteringPagingInfo[`d2dmap${key}`]){
            
            this.mapFiltersInfoObj[key] = Number(this.filteringPagingInfo[`d2dmap${key}`]);
          }else{
            this.mapFiltersInfoObj[key] = this.filteringPagingInfo[`d2dmap${key}`];
          }
        })
        if(!this.mapFiltersInfoObj.infoType && this.mapFiltersInfoObj.infoType != 0){
          this.mapFiltersInfoObj.infoType = 1;
        }
        this.getD2dMapListInfo();
      },
      manageD2DFilters(){
        Object.keys(this.d2dFiltersInfoObj).forEach((key) => {
          if(key == "search" || key == "startDateInputValue" || key == "endDateInputValue"){
            this.d2dFiltersInfoObj[key] = this.filteringPagingInfo[`d2d${key}`];
          }else if(key == "date"){

          }else if(this.filteringPagingInfo[`d2d${key}`]){
            this.d2dFiltersInfoObj[key] = Number(this.filteringPagingInfo[`d2d${key}`]);
          }else{
            this.d2dFiltersInfoObj[key] = this.filteringPagingInfo[`d2d${key}`];
          }
        })
        this.d2dFiltersInfoObj.date = this.d2dFiltersInfoObj.startDateInputValue?[this.d2dFiltersInfoObj.startDateInputValue??null, this.d2dFiltersInfoObj.endDateInputValue??null]:null;

        if(!this.d2dFiltersInfoObj.cityID){
          this.blockNextMultiselects(2, this.d2dFiltersMultiselectsArray, this.d2dFiltersInfoObj);
        }else if(!this.d2dFiltersInfoObj.regionID){
          this.blockNextMultiselects(3, this.d2dFiltersMultiselectsArray, this.d2dFiltersInfoObj);
        }

        if(this.d2dFiltersInfoObj.cityID){
          this.allowNextMultiselect(this.d2dFiltersInfoObj.cityID, 2, false, false, this.d2dFiltersMultiselectsArray, this.d2dFiltersInfoObj);
        }else if(this.d2dFiltersInfoObj.regionID){
          this.allowNextMultiselect(this.d2dFiltersInfoObj.cityID, 3, false, false, this.d2dFiltersMultiselectsArray, this.d2dFiltersInfoObj);
        }
        this.d2dPagingInfo.offset = this.filteringPagingInfo.d2dOffset?Number(this.filteringPagingInfo.d2dOffset) + 1:1;
        this.getD2DData();
        this.getCommonStatistics();
      },
      async getD2DData(){
        if(this.problemMultiselectArray[0].options.length == 0){
          await this.getDoorProblemType();
        }
        
        let customProblem = this.problemMultiselectArray[0].options.find((problemObj) => {
          return problemObj.value == this.d2dFiltersInfoObj.problemID;
        })?.label?.ge;
        
        let cutomDateRange = null;
        if(this.d2dFiltersInfoObj.startDateInputValue && this.d2dFiltersInfoObj.endDateInputValue){
          cutomDateRange = `${this.d2dFiltersInfoObj.startDateInputValue}_${this.d2dFiltersInfoObj.endDateInputValue}`;
        }
        this.$store.dispatch("getDoor2DoorData", {...this.d2dFiltersInfoObj, door_problem_type: customProblem, dateRange: cutomDateRange,
          offset: this.d2dPagingInfo.offset - 1, limit: this.d2dPagingInfo.limit,
        }).then((response) => {
          this.d2dDataArray = response.data[0];
          this.d2dPagingInfo.total = response.data[1];
        });
      },
      abortD2DDataDownload(){
        this.abortController?.abort();
        this.abortController = null;
      },
      async igniteDownload(){
        this.abortController = new AbortController();
        let firstArray = [];
        this.jsonToExcelArray = [];
        if(this.problemMultiselectArray[0].options.length == 0){
          await this.getDoorProblemType();
        }
        let customProblem = this.problemMultiselectArray[0].options.find((problemObj) => {
          return problemObj.value == this.d2dFiltersInfoObj.problemID;
        })?.label?.ge;
        let cutomDateRange = null;
        if(this.d2dFiltersInfoObj.startDateInputValue && this.d2dFiltersInfoObj.endDateInputValue){
          cutomDateRange = `${this.d2dFiltersInfoObj.startDateInputValue}_${this.d2dFiltersInfoObj.endDateInputValue}`;
        }
        this.$store.dispatch("getDoor2DoorData", {...this.d2dFiltersInfoObj, door_problem_type: customProblem, dateRange: cutomDateRange,
          offset: 0, limit: Number.MAX_SAFE_INTEGER, signal: this.abortController.signal,
        }).then((response) => {
          firstArray.push([
            "ქალაქი",
            "უბანი",
            "მისამართი",
            "დამატების თარიღი",
            "რა აწუხებს ხალხს",
            "დამოკიდებულება",
            "არჩვ.დასწრება",
            "პოზიცია",
            'სახელი',
            'გვარი',
            'ასაკი',
            'სქესი',
            'დაბადების თარიღი',
            'ტელეფონის ნომერი',
            'ქალაქი',
            'უბანი',
            'მისამართი',
            'ბინის ნომერი',
            'კომენტარი',
            'პასუხისმგებელი პირი',
            'ოფისი',
            'ოფისის ნომერი',
          ]);
          response.data[0].forEach((d2dObj) => {
            firstArray.push([
              d2dObj.city,
              d2dObj.region,
              d2dObj.address,
              this.$helper.get12HoursDate(`${d2dObj.input_date} ${d2dObj.input_time}`),
              d2dObj.door_problem_type,
              d2dObj.mood,
              d2dObj.going_type,
              d2dObj.party_type,
              d2dObj.flyer_fname,
              d2dObj.flyer_lname,
              d2dObj.flyer_age,
              d2dObj.gender,
              d2dObj.flyer_bdate,
              d2dObj.phone,
              d2dObj.city,
              d2dObj.region,
              d2dObj.address,
              d2dObj.flat_number,
              d2dObj.comment,
              d2dObj.pepoll_user,
              d2dObj.office_name,
              d2dObj.phone,
            ]);
          });
          this.jsonToExcelArray.push(firstArray);
          this.downloadInAction = !this.downloadInAction;
          this.abortController = null;

          
        }).catch((error) => {

        }).finally(() => {
          this.abortController = null;
          this.jsonToExcelArray = [];
        });
      },
      submitD2dMapFilters(){
        let tempObj = {};
        Object.keys(this.mapFiltersInfoObj).forEach((key) => {
          if((this.mapFiltersInfoObj[key] || this.mapFiltersInfoObj[key] === 0)){
            tempObj[`d2dmap${key}`] = this.mapFiltersInfoObj[key];
          }
        })
        this.activatedFilterMode = 2;
        let filteredQueries = {};
        Object.keys(this.$route.query).forEach((queryKey) => {
          if(this.mapFiltersInfoObj.hasOwnProperty(`${queryKey.slice(6)}`) && queryKey.startsWith("d2dmap")){
          }else{
            filteredQueries[queryKey] = this.$route.query[queryKey];
          }
        })
        this.$router.push({
          path: this.$route.path,
          query: {
            ...filteredQueries,
            ...tempObj,
          }
        });
      },
      submitD2DFilters(){
        let tempObj = {};
        if(this.$route.query.d2dOffset){
          tempObj.d2dOffset = 0;
        }
        Object.keys(this.d2dFiltersInfoObj).forEach((key) => {
          if((this.d2dFiltersInfoObj[key] || this.d2dFiltersInfoObj[key] === 0) && key != "date"){
            tempObj[`d2d${key}`] = this.d2dFiltersInfoObj[key];
          }
        })
        this.activatedFilterMode = 1;
        let filteredQueries = {};
        Object.keys(this.$route.query).forEach((queryKey) => {
          if(this.d2dFiltersInfoObj.hasOwnProperty(`${queryKey.slice(3)}`) && queryKey.startsWith("d2d")){
          }else{
            filteredQueries[queryKey] = this.$route.query[queryKey];
          }
        })
        
        this.$router.push({
          path: this.$route.path,
          query: {
            ...filteredQueries,
            ...tempObj,
          }
        });
      },
      resetSupportersFilters(){
        Object.keys(this.d2dFiltersInfoObj).forEach((key) => {
          this.d2dFiltersInfoObj[key] = null;
        });
        this.submitD2DFilters();
      },
      handleDate(modelDate){
        if(modelDate){
          this.d2dFiltersInfoObj.startDateInputValue = modelDate[0]??null;
          if(modelDate.length > 1){
            this.d2dFiltersInfoObj.endDateInputValue = modelDate[1]??null;
          }else{
            this.d2dFiltersInfoObj.endDateInputValue = null;
          }
        }else{
          this.d2dFiltersInfoObj.startDateInputValue = null;
          this.d2dFiltersInfoObj.endDateInputValue = null;
        }
      },
      handleModalFormDate(modelDate){
        if(modelDate){
          this.d2dModalFiltersInfoObj.date = modelDate;
        }else{
          this.d2dModalFiltersInfoObj.date = [];
        }
        if(this.modalMode == "commonStatisticflyers"){
          this.getCommonStatisticflyerstableInfo();
        }else if(this.modalMode == "commonStatisticOppositionOrPosition"){
          this.getCommonStatisticPartyTypetableInfo();
        }else if(this.modalMode == "commonStatisticMood"){
          this.getCommonStatisticMoodtableInfo();
        }else if(this.modalMode == "commonStatisticAttendance"){
          this.getCommonStatisticGoingTypetableInfo();
        }else if(this.modalMode == "commonStatisticProblems"){
          this.getCommonStatisticProblemstableInfo();
        }
      },
      updateModalFormSearch(value){
        this.d2dModalFiltersInfoObj.search = value;
        if(this.modalMode == "commonStatisticflyers"){
          this.getCommonStatisticflyerstableInfo();
        }else if(this.modalMode == "commonStatisticOppositionOrPosition"){
          this.getCommonStatisticPartyTypetableInfo();
        }else if(this.modalMode == "commonStatisticMood"){
          this.getCommonStatisticMoodtableInfo();
        }else if(this.modalMode == "commonStatisticAttendance"){
          this.getCommonStatisticGoingTypetableInfo();
        }else if(this.modalMode == "commonStatisticProblems"){
          this.getCommonStatisticProblemstableInfo();
        }
      },
      handleAscDescClick(ascDescButtonsArray, orderByButtonIndex, filterIndicatorVmodelObj){
        let sortSetString = "";
        ascDescButtonsArray.forEach((orderByButton, index) => {
          if(orderByButtonIndex == index){
              if(orderByButton.isActive){
                orderByButton.activeMode = !orderByButton.activeMode;
              }else{
                orderByButton.isActive = true;
                orderByButton.activeMode = false;
              }
              if(orderByButton.activeMode){
                sortSetString = `${orderByButton.setValue}:asc`;
              }else{
                sortSetString = `${orderByButton.setValue}:desc`;
              }
          }else{
            orderByButton.isActive = false;
            orderByButton.activeMode = false;
          }
        })
        filterIndicatorVmodelObj.sort = sortSetString;
        
      },
      seeProblem(d2dObj){
        this.seeProblemObj.props.name = d2dObj?.flyer_fname;
        this.seeProblemObj.props.surname = d2dObj?.flyer_lname;
        this.seeProblemObj.props.age = d2dObj?.flyer_age;
        this.seeProblemObj.props.gender = d2dObj?.gender;
        this.seeProblemObj.props.bornDate = d2dObj?.flyer_bdate;
        this.seeProblemObj.props.telephone = d2dObj?.flyer_phone;

        this.seeProblemObj.secondaryProps.city = d2dObj?.city;
        this.seeProblemObj.secondaryProps.region = d2dObj?.region;
        this.seeProblemObj.secondaryProps.address = d2dObj?.address;
        this.seeProblemObj.secondaryProps.flatNumber = d2dObj?.flat_number;

        this.seeProblemObj.problems = d2dObj?.door_problem_type?.split(',');
        this.seeProblemObj.additionalStatuses = [d2dObj?.going_type, d2dObj?.mood, d2dObj?.party_type];
        this.seeProblemObj.additionalComment = d2dObj?.comment;

        this.seeProblemObj.footerProps.responsiblePerson = d2dObj?.pepoll_user;
        this.seeProblemObj.footerProps.office = d2dObj?.office_name;
        this.seeProblemObj.footerProps.personPhone = d2dObj?.phone;
        
        // userDoorID
        if(d2dObj.seen == 0){
          this.$store.dispatch("seenUserDoorProblem", {user_doorID: d2dObj.user_doorID}).then((response) => {
            d2dObj.seen = 1;
          }).catch((error) => {
          });
        }
      },
      getCommonStatisticProblemstableInfo(){
        if(!this.d2dModalFiltersInfoObj.sort){
          this.d2dModalFiltersInfoObj.sort = this.problemsAscDescArray[0]?.setValue?`${this.problemsAscDescArray[0]?.setValue}:desc`:"";
        }
        this.$store.dispatch("user_door_problem_type_detail_counts", this.d2dModalFiltersInfoObj).then((response) => {
          this.modalLeftTableInfo = [];
          
          Object.keys(response.data).forEach((key) => {
            let sum = Object.values(response.data[key]).reduce((accumulator, num) => {
              return accumulator + num;
            }, 0);
            this.modalLeftTableInfo.push({
              name: key,
              details: {
                ...response.data[key],
                sum,
              },
            });
          });
        });
      },
      getCommonStatisticGoingTypetableInfo(){
        if(!this.d2dModalFiltersInfoObj.sort){
          this.d2dModalFiltersInfoObj.sort = this.attendanceAscDescArray[0]?.setValue?`${this.attendanceAscDescArray[0]?.setValue}:desc`:"";
        }

        this.$store.dispatch("user_door_going_type_detail_counts", this.d2dModalFiltersInfoObj).then((response) => {
          this.modalLeftTableInfo = [];
          
          Object.keys(response.data).forEach((key) => {
            let sum = Object.values(response.data[key]).reduce((accumulator, num) => {
              return accumulator + num;
            }, 0);
            this.modalLeftTableInfo.push({
              name: key,
              details: {
                ...response.data[key],
                sum,
              },
            });
          });
        });
      },
      getCommonStatisticMoodtableInfo(){
        if(!this.d2dModalFiltersInfoObj.sort){
          this.d2dModalFiltersInfoObj.sort = this.moodsAscDescArray[0]?.setValue?`${this.moodsAscDescArray[0]?.setValue}:desc`:"";
        }

        this.$store.dispatch("user_doors_mood_detail_counts", this.d2dModalFiltersInfoObj).then((response) => {
          this.modalLeftTableInfo = [];
          Object.keys(response.data).forEach((key) => {
            let sum = Object.values(response.data[key]).reduce((accumulator, num) => {
              return accumulator + num;
            }, 0);
            this.modalLeftTableInfo.push({
              name: key,
              details: {
                ...response.data[key],
                sum,
              },
            });
          });
        });
      },
      getCommonStatisticPartyTypetableInfo(){
        if(!this.d2dModalFiltersInfoObj.sort){
          this.d2dModalFiltersInfoObj.sort = this.oppositionOrPositionAscDescArray[0]?.setValue?`${this.oppositionOrPositionAscDescArray[0]?.setValue}:desc`:"";
        }

        this.$store.dispatch("user_door_party_type_detail_counts", this.d2dModalFiltersInfoObj).then((response) => {
          this.modalLeftTableInfo = [];
          Object.keys(response.data).forEach((key) => {
            // let sum = 0;
            // if(response.data[key].ოპოზიცია){
            //   sum += response.data[key].ოპოზიცია;
            // }
            // if(response.data[key].პოზიცია){
            //   sum += response.data[key].პოზიცია;
            // }
            // if(response.data[key].ნეიტრალური){
            //   sum += response.data[key].ნეიტრალური;
            // }
            let sum = Object.values(response.data[key]).reduce((accumulator, num) => {
              return accumulator + num;
            }, 0);
            this.modalLeftTableInfo.push({
              name: key,
              details: {
                ...response.data[key],
                sum,
              },
            });
          });
        });
        
      },
      getCommonStatisticflyerstableInfo(){
        if(!this.d2dModalFiltersInfoObj.sort){
          this.d2dModalFiltersInfoObj.sort = this.flyersAscDescArray[0]?.setValue?`${this.flyersAscDescArray[0]?.setValue}:desc`:"";
        }

        this.$store.dispatch("countsByCityAndFlyerTypes", this.d2dModalFiltersInfoObj).then((response) => {
          this.modalLeftTableInfo = [];
          Object.keys(response.data).forEach((key) => {
            // let sum = 0;
            // if(response.data[key].ბეჭდური){
            //   sum += response.data[key].ბეჭდური;
            // }
            // if(response.data[key].ციფრული){
            //   sum += response.data[key].ციფრული;
            // }
            let sum = Object.values(response.data[key]).reduce((accumulator, num) => {
              return accumulator + num;
            }, 0);
            this.modalLeftTableInfo.push({
              name: key,
              details: {
                ...response.data[key],
                sum,
              },
            });
          });
        });
      },
      getCommonStatisticflyersdataForGraph(){
        let xArray = [];
        let xtickText = [];
        let yArray = [];
        let xRange;
        let yRange;
        this.$store.dispatch("dataForGraph", this.d2dModalFiltersInfoObj.graphDate).then((response) => {
          response.data.forEach((countObj, i) => {
            xArray.push(i + 1);
            xtickText.push(countObj.date_name);
            yArray.push(countObj.fl_count);
          });
          xRange = [xArray.length - 7 >= 0?xArray.length - 7:0, xArray.length + 1];
          if(yArray.length - 8 >=0){
            if(yArray[yArray.length - 8] >= 1){
              yRange = [yArray[yArray.length - 8] - 1, yArray[yArray.length - 1] + 1];
            }else{
              yRange = [0, yArray[yArray.length - 1] + 1];
            }
          }else{
            if(yArray[0] >= 1){
              yRange = [yArray[0] - 1, yArray[yArray.length - 1] + 1];
            }else{
              yRange = [0, yArray[yArray.length - 1] + 1];
            }
          }
          this.initiateFlyersPlot(xArray, xtickText , yArray, xRange, yRange);
        });
      },
      activateModalMode(mode){
        this.modalMode = mode;
        
        if(this.modalMode == "seeProblem"){
          this.modalTitle = "დეტალურად";
          
          this.modalWidth = "1040px";
        }else if(this.modalMode == "commonStatisticflyers"){
          this.modalTitle = "ფლაერები";
        }else if(this.modalMode == "commonStatisticProblems"){
          this.modalTitle = "რა აწუხებს ხალხს";
        }else if(this.modalMode == "commonStatisticMood"){
          this.modalTitle = "პარტიის მიმართ დამოკიდებულება";
        }else if(this.modalMode == "commonStatisticAttendance"){
          this.modalTitle = "არჩევნებზე სავარაუდო დასწრება";
        }else if(this.modalMode == "commonStatisticOppositionOrPosition"){
          this.modalTitle = "ოპოზიცია / პოზიცია";
        }
        this.triggerModal(true);
      },
      triggerModal(Val){
        if(Val == false){
          this.modalMode = null;
          this.modalTitle = "";
          this.seeProblemObj.props = {};
          this.seeProblemObj.secondaryProps = {};
          this.seeProblemObj.footerProps = {};
          // this.seeProblemObj.placeholders = {};
          this.seeProblemObj.problems = [];
          this.seeProblemObj.additionalComment = null;
          this.seeProblemObj.additionalStatuses = null;
          this.checkedElementInModalReport = null;
          this.modalWidth = "1240px";
          this.modalLeftTableInfo = [];

          Object.keys(this.d2dModalFiltersInfoObj).forEach((key) => {
            this.d2dModalFiltersInfoObj[key] = null;
          });
          this.d2dModalFiltersInfoObj.graphDate = 1;
          this.resetCommonAscDescArray(this.flyersAscDescArray);
          this.resetCommonAscDescArray(this.problemsAscDescArray);
          this.resetCommonAscDescArray(this.moodsAscDescArray);
          this.resetCommonAscDescArray(this.attendanceAscDescArray);
          this.resetCommonAscDescArray(this.oppositionOrPositionAscDescArray);
        }
        this.showModal = Val;
      },
      resetCommonAscDescArray(ascDescArray){
        ascDescArray.forEach((ascDescObj, i) => {
          if(i == 0){
            ascDescObj.isActive = true;
          }else{
            ascDescObj.isActive = false;
          }
          ascDescObj.activeMode = false;
        })
      },
      initiateFlyersPlot(xArray, xtickText, yArray, xRange, yRange){
        setTimeout(() => {
          // let xArray = [50,60,70,80,90,100,110,120,130,140,150, 160];
          // let yArray = [7,8,8,9,9,9,10,11,14,14,15, 100];
          let customLabels = ['Low', 'Below Avg', 'Average', 'Above Avg', 'High'];
          // Define Data
          const data = [{
            x: xArray,
            y: yArray,
            mode:"lines+markers",
            marker: {
              size: 5,  // size of the dots
              color: 'blue', // fill color
              line: {
                color: 'blue', // border color
                width: 2, // border width
              },
              symbol: 'circle', // shape: 'circle', 'square', 'diamond', etc.
            },
            line: {
              color: 'lightblue', // optional: line color
            }
          }];
  
          // Define Layout
          const layout = {
            xaxis: {
              range: xRange, // must be array like [0, 100]
              title: {
                text: "",
              },
              tickvals: xArray,
              // ticktext: xArray.map((val, i) => `${customLabels[i % 5]}`),
              ticktext: xtickText,
              showgrid: true,
            },
            yaxis: {
              range: yRange, // must be array like [0, 100]
              title: "",
              showgrid: true,
              // font: {
              //   size: 24,
              //   color: "darkblue",
              //   family: "Arial, sans-serif"
              // }
            },  
            // title: {
            //   text: "plot title",
            //   x: 0.0,
            // },
            margin: {
              l: 50, // left
              r: 0, // right
              t: 20, // top
              b: 60  // bottom
            }
          };
  
          Plotly.newPlot("myPlot", data, layout);
        });
      },
      getD2dDetailsForMap(cityObj){
        if(!this.isD2dDetailsForMapComing){
          
          this.markerInfoArray = null;
          this.allowMapUnZoom = false;
          this.zoomedMarkerIndex = null;
          if(this.choosenMapListElementObj){
            this.choosenMapListElementObj.isChoosen = false;
          }
          cityObj.isChoosen = true;
          this.choosenMapListElementObj = cityObj;
          this.isD2dDetailsForMapComing = true;
          



          let localLabelKeyWord = "";
          switch (this.mapFiltersInfoObj.infoType) {
            case 1:
              localLabelKeyWord = "flyer_type";
              break;
            case 2:
              localLabelKeyWord = "door_problem_type";
              break;
            case 3:
              localLabelKeyWord = "mood";
              break;
            case 4:
              localLabelKeyWord = "party_type";
              break;
            case 5:
              localLabelKeyWord = "going_type";
              break;
            default:
              this.mapFiltersInfoObj.infoType = 1;
              localLabelKeyWord = "flyer_type";
              break;
          }

          let tempObj = {};
          this.$store.dispatch('latLngInfo', {rejimi: this.mapFiltersInfoObj.infoType, city: cityObj.city}).then((response) => {
            setTimeout(() => {
              this.isD2dDetailsForMapComing = false;
            }, 1000);
            response.data.forEach((markerInfo) => {
              if(tempObj[`${markerInfo.lat}:${markerInfo.lng}`]){
                tempObj[`${markerInfo.lat}:${markerInfo.lng}`].address += `${markerInfo[localLabelKeyWord]} - ${markerInfo.fl_count}\n`;
              }else{
                tempObj[`${markerInfo.lat}:${markerInfo.lng}`] = {
                  name: markerInfo.city,
                  latLng: {
                    lat: Number(markerInfo.lat),
                    lng: Number(markerInfo.lng),
                    altitude: 0,
                  },
                  // count: 1,
                  // ID: 123,
                  address: `${markerInfo[localLabelKeyWord]} - ${markerInfo.fl_count}\n`,
                  comment: `თარიღი: ${markerInfo.input_date}`,
                };
              }
            });
          
            this.markerInfoArray = Object.values(tempObj);
            if(this.markerInfoArray.length > 0){
              this.zoomOnIndexMarker(0);
            }
          });
          // let tempArray = [
          //   {
          //     name: "01.02",
          //     latLng: {
          //       lat: 41.3567,
          //       lng: 42.4567,
          //       altitude: 0,
          //     },
          //     count: 1,
          //     ID: 123,
          //     address: "varketili in action",
          //     comment: "comment in action",
          //   }
          // ]
          
        }
      },
      zoomOnIndexMarker(index){
        this.allowMapUnZoom = false;
        this.zoomedMarkerIndex = index;

      },
      allowNextMultiselect(value, index, clear, blockNext, changingArray, filterVModelsArray){
        if(value){
          if(index == 1){
            this.getCities(value, clear, changingArray, filterVModelsArray);
          }else if(index == 2){
            this.getRegions(value, clear, changingArray, filterVModelsArray);
          }
          
        }
        
        if(index < changingArray.length - 1 && blockNext){
          this.blockNextMultiselects(index + 1, changingArray, filterVModelsArray);
        }
      },
      blockNextMultiselects(index, changingArray, filterVModelsArray){
            
        if(index >= changingArray.length){
          return;
        }
            
        changingArray[index].options = [];
        if(index == 1){
          filterVModelsArray.cityID = null;
        }else if(index == 2){
          filterVModelsArray.regionID = null;
          changingArray[index].isDisabled = true;
        }
        
        this.blockNextMultiselects(index + 1, changingArray, filterVModelsArray);
      },
      getCities(valueID, clear, changingArray, filterVModelsArray){
        this.$store.dispatch("getCities",valueID).then((response) => {
          let tempArray = [];
          for(let obj of response.data){
            tempArray.push({
              value: obj.cityID,
              label: {
                ge: obj.city,
                en: obj.cityeng,
              },
            });
          }
          if(clear){
            filterVModelsArray.cityID = null;
          }
          changingArray[1].options = tempArray;
          changingArray[1].isDisabled = false;
        })
      },
      getRegions(valueID, clear, changingArray, filterVModelsArray){
        this.$store.dispatch("getRegions",valueID).then((response) => {
          
          let tempArray = [];
          for(let obj of response.data){
            tempArray.push({
              value: obj.regionID,
              label: {
                ge: `${obj.region} ${obj.pathID?`- ${obj.pathID}`:""}`,
                en: `${obj.regioneng} ${obj.pathID?`- ${obj.pathID}`:""}`,
              },
            });
          }
          if(clear){
            filterVModelsArray.regionID = null;
          }
          changingArray[2].options = tempArray;
          changingArray[2].isDisabled = false;
        })
      },
      // getDistricts(valueID, clear, changingArray, filterVModelsArray){
      //   this.$store.dispatch("getDistricts",valueID).then((response) => {
      //     let tempArray = [];
      //     for(let obj of response.data){
      //       tempArray.push({
      //         value: obj.districtID,
      //         label: {
      //           ge: obj?.district,
      //           en: obj?.district,
      //         },
      //       });
      //     }
      //     if(clear){
      //       filterVModelsArray.districtID = null;
      //     }
      //     changingArray[3].options = tempArray;
      //     changingArray[3].isDisabled = false;
      //   })
      // },
      getCitiesAll(changingArray){
        this.$store.dispatch("getCitiesAll").then((response) => {
          let tempArray = [];
          for(let obj of response.data){
            tempArray.push({
              value: obj.cityID,
              label: {
                ge: `${obj.city} ${obj.pathID?`- ${obj.pathID}`:""}`,
                en: `${obj.cityeng} ${obj.pathID?`- ${obj.pathID}`:""}`,
              },
            });
          }
          changingArray.forEach((destArray) => {
            destArray[1].options = tempArray;
            destArray[1].isDisabled = false;
          })
        })
      },
      paginationClickHandler(value){
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query, 
            d2dOffset: Number(value) - 1,
          }
        });
      },
      async getCommonStatistics(){
        Promise.all([
          this.$store.dispatch("user_doors_flyer_count"),
          this.$store.dispatch("user_doors_going_type_count"),
          this.$store.dispatch("user_doors_mood_count"),
          this.$store.dispatch("user_doors_party_type_count"),
          this.$store.dispatch("user_doors_problem_max_count"),
        ]).then((response) => {
          let flyer_count_sum = response[0].data.reduce((accumulator, flyerCountObj) => {
            return accumulator += flyerCountObj.fl_count;
          }, 0);
          let going_type_count_sum = response[1].data.reduce((accumulator, goingTypeCountObj) => {
            return accumulator += goingTypeCountObj.gt_count;
          }, 0);
          let mood_count_sum = response[2].data.reduce((accumulator, moodCountObj) => {
            return accumulator += moodCountObj.mood_count;
          }, 0);
          let party_type_count_sum = response[3].data.reduce((accumulator, partyTypeCountObj) => {
            return accumulator += partyTypeCountObj.pt_count;
          }, 0);
          
          this.commonStatisticsInfoObj = {
            flyer_count: response[0].data,
            flyer_count_sum: flyer_count_sum,
            going_type_count: response[1].data,
            going_type_count_sum: going_type_count_sum,
            mood_count: response[2].data,
            mood_count_sum: mood_count_sum,
            party_type_count: response[3].data,
            party_type_count_sum: party_type_count_sum,
            problem_max_count: response[4].data,
          };
        });
      },
      async getDoorProblemType(){
        await this.$store.dispatch("getDoorProblemType").then((response) => {
          this.problemMultiselectArray[0].options = response.data.map((problemObj) => {
            return {
              value: problemObj.door_problem_typeID,
              label: {
                ge: problemObj.door_problem_type,
                en: problemObj.door_problem_typeeng,
              }              
            }
          });

          this.problemsAscDescArray = response.data.map((problemObj, i) => {
            return {
              content: problemObj.door_problem_type,
              setValue: problemObj.door_problem_type,
              isActive: i == 0,
              activeMode: false,
            }
          });

        });
      },
      getOffices(){
        this.$store.dispatch('getOffices').then((response) => {
          this.officeMultiselectArray[0].options =  response.data.map((officeObj) => {
            return {
              value: officeObj.officeID,
              label: {
                ge: officeObj.office_name,
                en: officeObj.office_nameeng,
              }
            }
          });
        });
      },
      getMoods(){
        this.$store.dispatch('getMoods').then((response) => {
          
          this.moodMultiselectArray[0].options = response.data.map((moodObj) => {
            return {
              value: moodObj.moodID,
              label: {
                ge: moodObj.mood,
                en: moodObj.moodeng,
              }
            }
          });
          this.moodsAscDescArray = [];
          this.moodsAscDescArray = response.data.map((moodObj, i) => {
            let color = moodObj.moodID == 2?'#1FD286':(moodObj.moodID == 3?'#F32E21':'#131523');
            return {
              content: moodObj.mood,
              setValue: moodObj.mood,
              isActive: i == 0,
              activeMode: false,
              color,
              moodID: moodObj.moodID,
            }
          });
          
        });
      },
      getFlyerTypes(){
        this.$store.dispatch('flyerTypes').then((response) => {
          this.flyersAscDescArray = [];
          this.flyersAscDescArray = response.data.map((flyerTypeObj, i) => {
            return {
              content: flyerTypeObj.flyer_type,
              setValue: flyerTypeObj.flyer_type,
              isActive: i == 0,
              activeMode: false,
              color: flyerTypeObj.flyer_typeID == 1?"#1FD286":"#1E5EFF",
            }
          });
        });
      },
      getGoingTypes(){
        this.$store.dispatch('getGoingTypes').then((response) => {
          this.isGoingMultiselectArray[0].options = response.data.map((goingTypeObj) => {
            return {
              value: goingTypeObj.going_typeID,
              label: {
                ge: goingTypeObj.going_type,
                en: goingTypeObj.going_typeeng,
              }
            }
          });
          this.attendanceAscDescArray = [];
          this.attendanceAscDescArray = response.data.map((goingTypeObj, i) => {
            let color = goingTypeObj.going_typeID == 1?'#1FD286':(goingTypeObj.going_typeID == 2?'#F32E21':(goingTypeObj.going_typeID == 3?'#FFCB10':'#131523'));
            return {
              content: goingTypeObj.going_type,
              setValue: goingTypeObj.going_type,
              isActive: i == 0,
              activeMode: false,
              color,
              going_typeID: goingTypeObj.going_typeID,
            }
          });
        });
      },
      manageReportTrColoring(event, i){
        if(this.checkedElementInModalReport != null){
            this.checkedElementInModalReport.classList.remove("active");
        }
        let clickedElement = document.getElementById('modal-left-report-body').children[i];
        clickedElement.classList.add("active");
        this.checkedElementInModalReport = clickedElement;
      },
      removeAriaHidden(){
        Array.from(document.querySelectorAll('.multiselect span[aria-hidden]')).forEach((item) => {
          item.removeAttribute('aria-hidden');
        })
        Array.from(document.querySelectorAll('.multiselect .multiselect-search[aria-labelledby]')).forEach((item) => {
          item.removeAttribute('aria-labelledby');
        })
      },
    },
  };
  </script>
<style scoped lang="scss">
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, min-content);
  row-gap: 1.5em;
}
/* .statistics-info{
  font-size: 48px;
  font-family: "firaGo-700", Helvetica, Arial, sans-serif;
} */
.d2d-map-section{
  padding: 1.5em;
  border-radius: 0.7em;
  background-color: var(--secondary-background-color);
}
.d2d-map-section .map-list-element:hover{
  background-color: var(--light-blue);
}
.d2d-map-section .map-list-element:hover > .extra-gray-color{
  color: var(--secondary-background-color);
}
.d2d-map-section .map-list-element.active{
  background-color: var(--light-blue);
}
.d2d-map-section .map-list-element.active .extra-gray-color{
  color: var(--secondary-background-color);
}
.main-info-section{
  overflow: hidden;
}
.extra-large-text{
  font-size: 24px;
}
.common-secondary-statistics{
  display: grid;
  grid-template-columns: 40% 1fr 1fr;
  grid-template-rows: repeat(2, 1fr);
  gap: 1em;
  grid-auto-flow: column;
}
.common-secondary-statistics > :nth-child(1){
  grid-column: 1 / 2;
  grid-row: 1/ 3;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, 1fr);
  gap: 1em;


  padding: 1.5em;
  background-color: var(--secondary-background-color);
  border-radius: 0.7em;
}
  
/* for modal content >> */
.modal-form-grid-wrapper{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1em;
  row-gap: 1em;
}
.modal-form-grid-wrapper .blue-part-input{
  padding-block: 13px;
}
textarea.blue-part-input{
  width: 100%;
  resize: none;
}
/* << for modal content  */
.secondary-search-container-form{
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 2em;
  place-items: stretch start;
}
.secondary-search-container-form .primary-input{
  max-width: 360px;
}
.secondary-search-container-form .filters-wrapper{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(2, 1fr);
  place-items: stretch;
  gap: 0.7em;
}
.secondary-search-container-form .right-side{
  grid-column: 6 / 7;
  grid-row: 1 / 3;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 0.7em;
}
.secondary-search-container-form .right-side > *{
  padding: 0;
}
.secondary-search-container-form .filters-wrapper .multiselect, .multiselect.custom-multiselect{
  --ms-placeholder-color: var(--light-blue);
  --ms-tag-bg: var(--light-blue);
  --ms-option-bg-selected: var(--light-blue);
  --ms-option-bg-selected-pointed: var(--light-blue);
  flex: 1;
  width: 100%;
  max-width: 360px;
  min-width: 180px;
  margin: 0;
}
.secondary-search-container-form .filters-wrapper .dp__main{
  max-width: 360px;
  --dp-input-padding: 8px 30px 8px 12px;
}

/* for modal form >> */
.d2d-modal-form{
  display: grid;
  grid-template-columns: repeat(2, 270px);
  gap: 1em;
  place-items: stretch;
}
.modal-content-wrapper{
  .common-table-container{
    height: 540px;
    padding: 0;
    border-radius: 0;
    .common-tablee{
      min-width: 300px;
    }
  }
  .common-table-container :is(td, th){
    padding: 5px 5px;
  }
  .common-table-container th{
    text-overflow: ellipsis;  

  }
  .common-tablee td p{
    text-overflow: ellipsis;  
  }
}
/* << for modal form */


.modal-content-wrapper #modal-left-report-body tr{
    cursor: pointer;
}
.modal-content-wrapper #modal-left-report-body tr:hover{
    background-color: rgba(113, 142, 191, 0.705);
}
.modal-content-wrapper #modal-left-report-body tr.active{
    background-color: rgba(113, 142, 191, 0.705);
}

@media screen and (max-width: 1920px) {
    .common-statistics{
        grid-template-columns: repeat(4, 1fr);
    }
}
@media (max-width: 1720px) {
  .secondary-search-container-form .filters-wrapper .dp__main{
    max-width: 360px;
    --dp-input-padding: 6px 30px 6px 12px;
  }
  .modal-form-grid-wrapper .blue-part-input{
    padding: 12px;
  }
  .modal-content-wrapper{
    .common-table-container{
      height: 470px;
    }
  }

}



@media screen and (max-width: 1560px) {
  .modal-form-grid-wrapper{
    gap: 0.5em;
  }
  .modal-form-grid-wrapper .blue-part-input{
    padding: 10px;
    font-weight: 500;
  }
  .secondary-search-container-form .filters-wrapper .dp__main{
    max-width: 360px;
    --dp-input-padding: 4px 30px 4px 12px;
  }
  .secondary-search-container-form .filters-wrapper{
    gap: 0.5em;
  }
  .secondary-search-container-form .right-side{
    display: grid;
    grid-template-rows: 1fr 1fr;
    gap: 0.5em;
  }
  .modal-form-grid-wrapper .blue-part-input{
    padding: 10px;
  }
  .modal-content-wrapper{
    .common-table-container{
      height: 410px;
    }
  }
}
@media screen and (max-width: 1400px) {
    .common-statistics{
      grid-template-columns: repeat(3, 1fr);
    }
    .secondary-search-container-form{
      gap: 1em;
    }
}
@media screen and (max-width: 1260px) {
    .common-statistics{
      grid-template-columns: repeat(2, 1fr);
    }
    .secondary-search-container-form{
      grid-template-columns: 1fr;
    }
    .secondary-search-container-form .filters-wrapper{
      grid-template-columns: repeat(5, 1fr);
      grid-column: 1 / 2;
    }
    .secondary-search-container-form .right-side{
      place-items: stretch center; 
      grid-column: 1 / 6;
      grid-row: 3 / 4;
    }
    .secondary-search-container-form .right-side > *{
      max-width: 500px;
      width: 100%;
      padding: 8px 12px;
    }
}
@media (max-width: 1100px) {
  .secondary-search-container-form .filters-wrapper{
    grid-column: 1 / 2;
    grid-template-columns: repeat(3, 1fr);
  }
  .secondary-search-container-form .right-side{
    place-items: stretch center; 
    grid-column: 1 / 4;
    grid-row: 5 / 6;
  }
}
@media (max-width: 992px) {
  .respodent-comments-wrapper{
    padding-inline: 1em;
    height: 280px;
  }
}
@media screen and (max-width: 778px) {
    .common-statistics{
      grid-template-columns: repeat(1, 1fr);
    }
    .secondary-search-container-form .primary-input{
      max-width: none;
    }
    .secondary-search-container-form .filters-wrapper{
      grid-template-columns: 1fr;
    }
    .secondary-search-container-form .right-side{
      place-items: stretch center;
      grid-column: 1 / 2;
      grid-row: 11 / 12;
    }
    .secondary-search-container-form .filters-wrapper :is(.multiselect, .multiselect.custom-multiselect, .dp__main) {
      max-width: none;
    }
}
</style>
  